export default {
  slug: 'not-registered'
}
